import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { ARTICLE_MASTER_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const ArticleMasterApi = createApi({
  reducerPath: "ArticleMaster",
  baseQuery,
  tagTypes: ["Article"],
  endpoints: (builder) => ({
    getArticle: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: ARTICLE_MASTER_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: ARTICLE_MASTER_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["Article"],
    }),
    getArticleById: builder.query({
      query: (id) => {
        return {
          url: `${ARTICLE_MASTER_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["Article"],
    }),
    addArticle: builder.mutation({
      query: (payload) => ({
        url: ARTICLE_MASTER_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["Article"],
    }),
    updateArticle: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${ARTICLE_MASTER_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Article"],
    }),
    deleteArticle: builder.mutation({
      query: (id) => ({
        url: `${ARTICLE_MASTER_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Article"],
    }),
  }),
});

export const {
  useAddArticleMutation, useDeleteArticleMutation, useUpdateArticleMutation, useGetArticleQuery, useGetArticleByIdQuery
} = ArticleMasterApi;

export default ArticleMasterApi;
